import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { renderDate } from '../../shared/dateHelpers';

class AuditTab extends PureComponent {
  static propTypes = {
    taxEntry: PropTypes.shape({
      createdOn: PropTypes.string,
      method: PropTypes.string,
      batchId: PropTypes.string,
      preparerName: PropTypes.string,
      createdSso: PropTypes.string,
      reviewerName: PropTypes.string,
      reviewedSso: PropTypes.string,
    }),
  };

  render() {
    const {
      createdOn,
      method,
      batchId,

      preparerName,
      createdSso,

      reviewerName,
      reviewedSso,
    } = this.props.taxEntry;

    const createdOnFormatted = createdOn
      ? renderDate(createdOn)
      : null;

    return (
      <div className="audit-tab">
        <div className="row content">
          <div className="col-12 col-sm-3">
            <div className="row">
              <div className="col-6">Entry Date</div>
              <div className="col-6 value">{createdOnFormatted}</div>
              <div className="col-6">Method</div>
              <div className="col-6 value">{method}</div>
              <div className="col-6">Batch Name</div>
              <div className="col-6 value">{batchId}</div>
            </div>
          </div>
          <div className="col-12 col-sm-3">
            <div className="row preparer">
              <div className="col-12">Preparer</div>
              <div className="col-6">User</div>
              <div className="col-6 value">{preparerName}</div>
              <div className="col-6">SSO</div>
              <div className="col-6 value">{createdSso}</div>
            </div>
          </div>
          <div className="col-12 col-sm-3">
            <div className="row reviewer">
              <div className="col-12">Reviewer</div>
              <div className="col-6">User</div>
              <div className="col-6 value">{reviewerName}</div>
              <div className="col-6">SSO</div>
              <div className="col-6 value">{reviewedSso}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AuditTab;
